import Entity from '../entity'
import MeasureUnit from '../catalogs/measureunit';
import Product from '../catalogs/product';

export default class OrderDetail extends Entity<number>{
    order_id: number;
    product_id: number;
    warehouse_id: number;
    unity_id: number;
    current_state_id: number;
    code: string;
    product_name: string;
    stock: number;
    quantity: number;
    discount_type: string;
    unit_price: number;
    price: number;
    price_wt: number;
    discounts: number;
    taxes: number;
    total: number;
    total_wt: number;
    product_price: number;
    product_cost: number;
    note: string;
    service: boolean;
    gift: boolean;

    discount_manual: boolean;
    unity_sym: string;
    unity: MeasureUnit;
    product: Product;
    tax_rate: number;
    state_color: string;

}


